"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _systemSetting = require("@/api/systemSetting");
var _jsCookie = _interopRequireDefault(require("js-cookie"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'EditorSlideUpload',
  props: {
    color: {
      type: String,
      default: '#1890ff'
    },
    // sourceType属性用于区分来源类型
    sourceType: {
      type: String,
      default: 'dental' // 默认为口腔商品，使用本地上传
    }
  },
  data: function data() {
    return {
      dialogVisible: false,
      listObj: {},
      fileList: [],
      sortDialogVisible: false,
      pendingUrls: [],
      dragIndex: -1
    };
  },
  methods: {
    // 根据sourceType处理上传逻辑
    handleUpload: function handleUpload() {
      if (this.sourceType === 'spu' || this.sourceType === 'sku') {
        // this.openImageLibrary();
        // SPU和SKU使用公共上传组件，判断用户是否位总平台用户
        var javaInfo = JSON.parse(_jsCookie.default.get('JavaInfo'));
        if (javaInfo.type === 1) {
          this.openImageLibrary();
        } else {
          this.openLocalUpload();
        }
      } else if (this.sourceType === 'spu2' || this.sourceType === 'sku2') {
        // SPU2和SKU2使用Windows本地文件上传
        this.openLocalUpload();
      } else {
        // 其他类型默认使用本地上传
        this.openLocalUpload();
      }
    },
    // 打开图片库选择
    openImageLibrary: function openImageLibrary() {
      var _this = this;
      var isSpuDetail = ['spu', 'sku', 'spu2', 'sku2'].includes(this.sourceType);
      var uploadOptions = isSpuDetail ? {
        maxSizeKB: 5120,
        maxSizeErrorMsg: '请上传大小≤5MB的图片！'
      } : {};
      this.$modalUpload(function (img) {
        if (!img || img.length === 0) return;
        var arr = [];
        if (img.length > 10) return this.$message.warning('最多选择10张图片！');
        var _iterator = _createForOfIteratorHelper(img),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            if (isSpuDetail && !_this.validateDetailImage(item)) return;
            if (!item.num) {
              item.num = 1;
            }
            arr.push(item.sattDir);
          }
          // 超过1张图片时显示排序弹窗
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        if (arr.length > 1) {
          _this.showSortDialog(arr);
        } else {
          _this.$emit('successCBK', arr);
        }
      }, '选择图片', 'content', false, uploadOptions);
    },
    // 打开本地文件选择窗口上传图片
    openLocalUpload: function openLocalUpload() {
      // 创建隐藏的文件输入元素
      var input = document.createElement('input');
      input.type = 'file';
      input.multiple = true;
      input.accept = 'image/*';
      var _this = this;

      // 处理文件选择后的逻辑
      input.onchange = function (e) {
        var files = e.target.files;
        if (!files || files.length === 0) return;

        // 限制最多上传10张图片
        var maxFiles = 10;
        var selectedFiles = Array.from(files).slice(0, maxFiles);
        if (files.length > maxFiles) {
          _this.$message.warning("\u6700\u591A\u9009\u62E9".concat(maxFiles, "\u5F20\u56FE\u7247\uFF01\u5DF2\u81EA\u52A8\u9009\u62E9\u524D").concat(maxFiles, "\u5F20"));
        }

        // 显示上传中的loading状态
        var loadingInstance = _this.$loading({
          lock: true,
          text: '图片上传中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });

        // 收集所有上传Promise用于等待所有图片上传完成
        var uploadPromises = [];
        var successUrls = [];

        // 处理每个文件上传
        var isSpuDetail = ['spu', 'sku', 'spu2', 'sku2'].includes(_this.sourceType);
        var maxSize = isSpuDetail ? 5 * 1024 * 1024 : 0;
        selectedFiles.forEach(function (file) {
          if (maxSize && file.size > maxSize) {
            _this.$message.error('请上传大小≤5MB的图片！');
            return;
          }
          var formData = new FormData();
          formData.append('multipart', file);

          // 设置上传参数
          var params = {
            model: 'content',
            // 使用content模块
            pid: 1 // 默认分类ID
          };

          // 将上传Promise添加到数组
          var uploadPromise = (0, _systemSetting.fileImageApi)(formData, params).then(function (response) {
            if (response && response.url) {
              successUrls.push(response.url);
            }
          }).catch(function (error) {
            console.error('Upload error:', error);
            _this.$message.error("\u6587\u4EF6 ".concat(file.name, " \u4E0A\u4F20\u5931\u8D25: ").concat(error.message || '未知错误'));
          });
          uploadPromises.push(uploadPromise);
        });

        // 等待所有上传完成
        Promise.all(uploadPromises).then(function () {
          if (successUrls.length > 0) {
            // 超过1张图片时显示排序弹窗
            if (successUrls.length > 1) {
              _this.showSortDialog(successUrls);
            } else {
              _this.$emit('successCBK', successUrls);
            }
          } else {
            // _this.$message.warning('没有图片上传成功');
          }
        }).finally(function () {
          loadingInstance.close();
        });
      };

      // 触发文件选择
      input.click();
    },
    validateDetailImage: function validateDetailImage(imageData) {
      var maxSize = 5 * 1024 * 1024;
      var sizeBytes = this.parseAttachmentSizeBytes(imageData);
      if (sizeBytes != null && sizeBytes > maxSize) {
        this.$message.error('请上传大小≤5MB的图片！');
        return false;
      }
      return true;
    },
    parseAttachmentSizeBytes: function parseAttachmentSizeBytes(item) {
      if (!item) return null;
      var raw = item.attSize || item.att_size || item.fileSize || item.size;
      if (raw == null || raw === '') return null;
      if (typeof raw === 'number') {
        return raw > 1024 * 500 ? raw : raw * 1024;
      }
      var str = String(raw).trim();
      var kbMatch = str.match(/^([\d.]+)\s*KB$/i);
      if (kbMatch) return parseFloat(kbMatch[1]) * 1024;
      var mbMatch = str.match(/^([\d.]+)\s*MB$/i);
      if (mbMatch) return parseFloat(mbMatch[1]) * 1024 * 1024;
      var bMatch = str.match(/^([\d.]+)\s*B$/i);
      if (bMatch) return parseFloat(bMatch[1]);
      var num = parseFloat(str);
      if (!isNaN(num)) return num;
      return null;
    },
    // 显示排序弹窗
    showSortDialog: function showSortDialog(urls) {
      this.pendingUrls = _toConsumableArray(urls);
      this.sortDialogVisible = true;
    },
    // 确认插入排序后的图片
    confirmInsert: function confirmInsert() {
      this.$emit('successCBK', this.pendingUrls);
      this.sortDialogVisible = false;
    },
    // 拖拽开始
    onDragStart: function onDragStart(index) {
      this.dragIndex = index;
    },
    // 拖拽经过
    onDragOver: function onDragOver(index) {
      if (this.dragIndex === -1 || this.dragIndex === index) return;
      var item = this.pendingUrls.splice(this.dragIndex, 1)[0];
      this.pendingUrls.splice(index, 0, item);
      this.dragIndex = index;
    },
    // 拖拽结束
    onDragEnd: function onDragEnd() {
      this.dragIndex = -1;
    }
  }
};